import _ from 'underscore';

function AddAttributionSourcePanelCtrl($scope, $panelInstance, attributionSource, attributionSourceService, organizationService, alertService, sdkUtils) {
  _initScope();

  function _initScope() {
    $scope.attributionSource = attributionSource;
    $scope.attributionSourceForm = attributionSource ? _.extend({}, attributionSource) : {};

    $scope.closePanel = function ($event) {
      if ($event) $event.preventDefault();

      $panelInstance.close(false);
    };

    $scope.saveAttributionSource = function (form, $event) {
      if ($event) $event.preventDefault();

      $scope.submitted = true;

      if (!form.$valid) return;

      $scope.submitted = false;
      $scope.saving = true;

      const currentUserOrganization = organizationService.getCurrentOrganization();

      let promise;

      if (!$scope.attributionSource) {
        promise = attributionSourceService.createByOrganizationId(currentUserOrganization.id, {
          name: $scope.attributionSourceForm.name
        });
      } else {
        promise = attributionSourceService.updateByIdAndOrganizationId($scope.attributionSource.id, currentUserOrganization.id, {
          name: $scope.attributionSourceForm.name
        });
      }

      promise
        .then(result => {
          $panelInstance.close({
            attributionSource: result
          });

          $scope.saving = true;
          $scope.submitted = false;
        })
        .catch(response => {
          $scope.saving = true;
          $scope.submitted = false;

          alertService.error(sdkUtils.getErrorFromResponse(response));
        });
    };
  }
}

AddAttributionSourcePanelCtrl.$inject = [
  '$scope',
  '$panelInstance',
  'attributionSource',
  'jsSdk.attributionSource',
  'organizationService',
  'alertService',
  'jsSdk.utils'
];

export default AddAttributionSourcePanelCtrl;



// WEBPACK FOOTER //
// ./src/panels/addAttributionSource/controller.js